import type { ClientStatusObj, EditEmailAPIClientFormInputs, EmailAPIClientFormInputs } from 'src/components/types/types';
import httpEmailAPI from '../common/http-email-api'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllEmailAPIClient = async () => {
    const response = httpEmailAPI.get(`/client/all`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const changeStatusClientData = async (data: ClientStatusObj) => {
    const response = httpEmailAPI.patch(`/client/activate`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const addClientData = async (data: EmailAPIClientFormInputs) => {
    const response = httpEmailAPI.post(`/client/add`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getClientDetailsById = async (id: string) => {
    const response = httpEmailAPI.get(`/client/${id}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateClientData = async (data: EditEmailAPIClientFormInputs) => {
    const response = httpEmailAPI.put(`/client/update`, data)
    return response;
}

